export enum SectionType {
  TRACK = 'TRACK',
  MODULE = 'MODULE',
  PRODUCT = 'PRODUCT',
  SALE = 'SALE',
  PURCHASED = 'PURCHASED',
  PROGRESS = 'PROGRESS'
}

export enum SectionProductDetailStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  DELETED = 'DELETED',
  IN_REVIEW = 'IN_REVIEW',
  NOT_APPROVED = 'NOT_APPROVED',
  CHANGES_PEDING_ON_PRODUCT = 'CHANGES_PEDING_ON_PRODUCT'
}
